import { Action } from "redux";
import { Alert } from "../types/index.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["SHOW_ALERT", "REMOVE_ALERT"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type ShowAlert = ActionBase<"SHOW_ALERT"> & {
  text: string;
  alertType: Alert["type"] | undefined;
};
type RemoveAlert = ActionBase<"REMOVE_ALERT"> & { id: string };

export type AlertsAction = ShowAlert | RemoveAlert;

export const isAlertsAction = (action: Action): action is AlertsAction =>
  isActionType(action, ActionTypeKeys);

export function showAlert(text: string, alertType?: Alert["type"]): ShowAlert {
  return { type: "SHOW_ALERT", text, alertType };
}

export function removeAlert(id: string): RemoveAlert {
  return { type: "REMOVE_ALERT", id };
}
